<template>

	<modal-dialog
		:modal-visible="visible"
		:title="title"
		confirm-button-text="Save"
		v-on:confirm="saveLocation"
		v-on:closeModal="closeModal">

		<field
			label="Location Name"
			col-class="col-sm-4"
			v-model="payload.location_name"
			:invalid="$store.errorList.location_name">
		</field>

		<field label="Location Notes"
			col-class="col-sm-4"
			v-model="payload.notes"
			:params="{'type': 'textarea'}"
			:invalid="$store.errorList.notes">
		</field>

		<hr>

		<field label="Email"
			col-class="col-sm-4"
			v-model="payload.email"
			:params="{'type': 'text'}"
			:invalid="$store.errorList.email">
		</field>

		<field label="Phone #"
			col-class="col-sm-4"
			v-model="payload.phone"
			:params="{'type': 'text'}"
			:invalid="$store.errorList.phone">
		</field>

		<hr>

		<address-manual-selector
			col-class="col-sm-4"
			:suite="payload.suite"
			:address="payload.address"
			:city="payload.city"
			:province="payload.province"
			:country="payload.country"
			:postal-code="payload.postal_code"
			v-on:input="updateLocation">
		</address-manual-selector>

		<div>
			<button v-if="!showMap" class="btn btn-sm btn-light mr-2" v-on:click="showMap = true" type="button">Show Map...</button>

			<button v-if="!showMoveLocation && 'id' in payload" class="btn btn-sm btn-light" type="button" v-on:click="moveLocation">Move Location to Different Contact...</button>
		</div>

		<iframe
			v-if="visible && mapsSrc && showMap"
			width="100%"
			height="250"
			frameborder="0" style="border:0"
			sandbox="allow-scripts allow-same-origin"
			:src="mapsSrc" allowfullscreen>
		</iframe>

		<div v-if="showMoveLocation">
			<field label="Destination Contact"
				col-class="col-sm-4"
				:params="{
					type: 'select',
					options: contactOptions
				}"
				v-model="moveLocationContactId">
			</field>
		</div>

		<button v-if="'id' in payload && payload.id" slot="footer" class="btn btn-outline-danger" type="button" v-on:click="deleteModalVisible = true">
			<i class="fa fa-trash"></i>
			Delete Location
		</button>

		<modal-dialog
			:modal-visible="deleteModalVisible"
			title="Delete Location"
			confirm-button-text="Yes, Delete"
			button-class="btn-outline-danger"
			v-on:confirm="deleteLocation"
			v-on:closeModal="deleteModalVisible = false">

			Are you sure you want to delete this location?
		</modal-dialog>

	</modal-dialog>
</template>
<script type="text/javascript">

import ModalDialog from "../ModalDialog"
import Field from "../Field"
import AddressManualSelector from "@/components/AddressManualSelector"

export default {
	name: "ContactLocationEditModal",
	components: {
		ModalDialog,
		Field,
		AddressManualSelector
	},
	props: [
		"visible",
		"record",
		"contactId"
	],
	data() {
		return {
			payload: {},
			contacts: [],
			showMap: false,
			showMoveLocation: false,
			moveLocationContactId: null,
			deleteModalVisible: false
		}
	},
	watch: {
		record() {
			this.resetPayload()
		},
		visible() {
			if (this.visible) {
				this.resetPayload()
				this.showMap = false
			}
		}
	},
	computed: {
		mapsSrc() {
			let address_query

			if (this.payload.lat && this.payload.long)
				address_query = this.payload.lat+","+this.payload.long
			else
				address_query = this.payload.address+"+"+this.payload.city+"+"+this.payload.province+"+"+this.payload.country+"+"+this.payload.postal_code

			if (!this.payload.address)
				return false

			return 'https://www.google.com/maps/embed/v1/place?key='+this.$store.GoogleEmbedAPIkey+"&q="+address_query
		},
		title() {
			return ('id' in this.payload) ? "Edit Location" : "New Location"
		},
		contactOptions() {
			return this.optionify(this.contacts,"name")
		}
	},
	methods: {
		closeModal() {
			this.$emit("closeModal")
		},
		deleteLocation() {
			const vm = this

			const payload = {
				id: this.payload.id
			}

			this.postData('ContactLocation/delete', payload).then(response => {
				if (response.success) {
					vm.deleteModalVisible = false
					vm.$emit('closeModal')
					vm.$emit('locationDeleted', payload.id)
				}
			})
		},
		moveLocation() {
			this.showMoveLocation = true
			this.moveLocationContactId = null
			if (this.contacts.length == 0)
				this.fetchContacts()
		},
		saveLocation() {
			const vm = this

			if (!('contact_id' in this.payload) && this.contactId)
				this.payload.contact_id = this.contactId

			if (this.showMoveLocation && this.moveLocationContactId)
				this.payload.contact_id = this.moveLocationContactId

			this.postData('ContactLocation/save', this.payload, true).then(response => {
				if (response.success) {
					vm.showMoveLocation = false
					vm.moveLocationContactId = null
					vm.$emit('closeModal')
					vm.$emit('locationSaved', response.data.record_id)
				}
			})
		},
		updateLocation(address) {

			Object.keys(address).forEach(key => {
				this.$set(this.payload, key, address[key])
			})
		},
		fetchContacts() {
			let vm = this

			let params = {
				filters: [
					["contact_id",0]
				]
			}

			this.getJSON("Contact/get",params).then(response => {
				if (response.success)
					vm.contacts = response.data
			})
		},
		resetPayload() {
			this.payload = (this.record) ? this.cloneObj(this.record) : {}
		}
	},
	created() {
		this.resetPayload()
	}
}	
</script>